import * as actionTypes from '../actions/actionTypes';

export default function currentProductInterestEnhancement(state = {}, action) {
    switch(action.type){

        case actionTypes.SAVE_INTEREST_ENHANCEMENT: {
          let newState = {...state};
          newState.data = action.data;
          return newState;
        }
        case actionTypes.SAVE_INTEREST_ENHANCEMENT_ACCOUNTS: {
          let newState = {...state};
          newState.accounts = action.acc;
          return newState;
        }
        case actionTypes.SAVE_INTEREST_ENHANCEMENT_COUNTRY_LIST: {
          let newState = {...state};
          newState.countries = action.countries;
          return newState;
        }
        case actionTypes.SAVE_INTEREST_ENHANCEMENT_CURRENCY: {
          let newState = {...state};
          newState.currencies = action.currencies;
          return newState;
        }
        case actionTypes.SET_DELETED_TIER_INDEX: {
          let newState = {...state};
          newState.deletedIndex = action.deletedIndex;
          return newState;
        }
        case actionTypes.RESET_DELETED_TIER_INDEX: {
          let newState = {...state};
          newState.deletedIndex = '';
          return newState;
        }
        case actionTypes.SET_PREMIUM_MARGIN_VALUE: {
          let newState = {...state};
          newState.data = {
            ...state.data,
            marginApplicable: action.val || false
          }
          return newState;
        }
        case actionTypes.SET_IE_TAB_STATUS: {
            let newState = {...state}
            newState.ieTabStatus = action.data
            return newState;
        }
      default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/reducer/interestEnhancementReducer.js